import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { defaultConverter, LitElement, notEqual } from 'lit-element';
import { onHtmlDirChange, offHtmlDirChange, getHtmlDir } from '../../utils/rtl-utils';
import '../../metrics/register-component-metrics';
import { coerceToBoolean } from './type-utils';
const DEFAULT_REFLECT_ATTRIBUTES = [String, Number, Boolean];
const defaultPropertyDeclaration = {
  attribute: true,
  type: String,
  converter: defaultConverter,
  hasChanged: notEqual
};
export class KatLitElement extends LitElement {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_listeners", []);
    _defineProperty(this, "__updateRtl", val => {
      if (!val) {
        this.removeAttribute('dir');
      } else {
        this.setAttribute('dir', val);
      }
    });
  }
  initialize() {
    super.initialize();
    if (this.renderRoot !== this && !this.renderRoot.adoptedStyleSheets?.length) {
      this.adoptStyles();
    }
  }
  connectedCallback() {
    window.dispatchEvent(new CustomEvent('katal-component-connected', {
      detail: {
        element: this
      }
    }));
    this.__updateRtl(getHtmlDir());
    onHtmlDirChange(this.__updateRtl);
    super.connectedCallback();
    this._listeners.forEach(listener => {
      if (!Array.isArray(listener)) {
        listener.listeners.forEach(ctx => {
          listener.target.addEventListener(...ctx);
        });
      }
    });
  }
  disconnectedCallback() {
    offHtmlDirChange(this.__updateRtl);
    super.disconnectedCallback();
    this._listeners.forEach(listener => {
      if (!Array.isArray(listener)) {
        listener.listeners.forEach(ctx => {
          listener.target.removeEventListener(...ctx);
        });
      }
    });
  }
  dispatchCustomEvent(eventType, detail, bubbles = true) {
    const evt = new CustomEvent(eventType, {
      detail,
      ...(typeof bubbles === 'boolean' ? {
        bubbles
      } : bubbles)
    });
    return this.dispatchEvent(evt);
  }
  firstUpdated() {
    this._listeners.forEach(ctx => {
      if (Array.isArray(ctx)) {
        this.addEventListener(...ctx);
      }
    });
  }
  observeChildren(parentOrCallback, callback) {
    let parent;
    if (typeof parentOrCallback === 'function') {
      callback = parentOrCallback;
      parent = this;
    } else {
      parent = parentOrCallback;
    }
    const observer = new MutationObserver(callback);
    observer.observe(parent, {
      childList: true
    });
    return observer;
  }
  static createProperty(name, options = defaultPropertyDeclaration) {
    const reflect = options.attribute !== false && shouldReflectType(options.type);
    super.createProperty(name, {
      reflect,
      ...options
    });
  }
  static getPropertyDescriptor(name, key, options) {
    const descriptor = super.getPropertyDescriptor(name, key, options);
    if (options.type === Boolean) {
      descriptor.set = createDescriptorSetter(name, key, coerceToBoolean);
    }
    return descriptor;
  }
  _shadow(selector) {
    return this.shadowRoot.querySelector(selector);
  }
}
function createDescriptorSetter(name, key, coerce) {
  return function (value) {
    const oldValue = this[name];
    this[key] = coerce(value);
    this.requestUpdate(name, oldValue);
  };
}
function shouldReflectType(type) {
  return type == null || DEFAULT_REFLECT_ATTRIBUTES.indexOf(type) !== -1;
}
//# sourceMappingURL=kat-lit-element.js.map